import queryString from 'query-string'

export default function removeModalFromQuery (search) {
  let query = queryString.parse(search)
  delete query.m
  return queryString.stringify(query)
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/removeModalFromQuery.js